import styled from 'styled-components/macro';
import {useState} from "react";
import {
    Button,
    FormControl,
    FormErrorMessage,
    FormHelperText,
    FormLabel,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Stack,
    Textarea
} from "@chakra-ui/react";
import {useHistory} from "react-router-dom";
import {useFeedback} from "../store/feedback";
import {useCreateCommunity} from "../api/communities";
import {useLoggedIn, useModal, useSettings} from "../store";
import {useReloadProfile} from "../api/user";
import CommunityOnboarding from "./community_onboarding";

const CreateCommunity = styled(({onClose}) => {
    const modal = useModal();
    const loggedIn = useLoggedIn();
    const {community_creation: canCreateCommunities} = useSettings();
    const {error, feedbackCh} = useFeedback();
    const [post, setPost] = useState({
        name: '',
        displayName: '',
        description: '',
        politics: false,
        nsfw: false,
    });
    const set = (name) => (value) => setPost((post) => ({...post, [name]: value}));
    const [posting, setPosting] = useState(false);
    const history = useHistory()

    const createCommunity = useCreateCommunity(feedbackCh);
    const reloadProfile = useReloadProfile(feedbackCh);
    const handleCreate = async () => {
        setPosting(true);
        try {
            await createCommunity(post.name, post.displayName, post.description, post.politics, post.nsfw);
            await reloadProfile();
            onClose();
            modal.open(CommunityOnboarding, {community: post.name});
        } catch (error) {
        }
        setPosting(false);
    };

    return (
        <>
            <Modal
                isOpen
                onClose={onClose}
                size={'xl'}
                closeOnOverlayClick={false}
            >
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Create a community</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody pb={6}>

                        {canCreateCommunities ?

                            <Stack spacing={'5'}>

                                <FormControl>
                                    <FormLabel>Name</FormLabel>
                                    <Input placeholder="Cats" value={post.name}
                                           onChange={(e) => set('name')(e.currentTarget.value)}/>
                                    <FormHelperText>This cannot be changed later.</FormHelperText>
                                </FormControl>

                                <FormControl>
                                    <FormLabel>Display Name</FormLabel>
                                    <Input placeholder="Cats" value={post.displayName}
                                           onChange={(e) => set('displayName')(e.currentTarget.value)}/>
                                </FormControl>

                                <FormControl>
                                    <FormLabel>What's your community about?</FormLabel>
                                    <Textarea placeholder="A community for discussing cats." value={post.description}
                                              onChange={(e) => set('description')(e.currentTarget.value)}/>
                                </FormControl>

                                <FormControl isInvalid={error}>
                                    <FormErrorMessage>{error?.toString()}</FormErrorMessage>
                                </FormControl>

                            </Stack>

                            : (loggedIn ? <>Sorry, you can't create communities right now.</> : <>You must be logged in.</>)}

                    </ModalBody>

                    <ModalFooter>
                        <Button variant="cancel" mr={3} onClick={onClose}>Cancel</Button>
                        {canCreateCommunities && <Button variant="blue" isLoading={posting} onClick={handleCreate}>
                            Create
                        </Button>}
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    )
})``;

export default CreateCommunity;
